import { Button, Checkbox } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import "../AddNewProject.css";

const DuplicateProjectModal = ({
  handleCancel,
  handleContinue,
  show,
  duplicateProjectData,
  blocking
}) => {
  const [itemCount, setItemCount] = useState(1);
  const [pluralizer, setPluralizer] = useState("");
  const [isUnlisted, setIsUnlisted] = useState(false);
  const [exactMatch, setExactMatch] = useState(false)

  useEffect(() => {
    // TEMPORARY FOR BACKWARDS COMPATIBILITY
    duplicateProjectData.forEach(item => {
      item.zip5 = item.zip5 || item.zipcode;
      item.zipcode = item.zip5;
      item.unitCount = item.unitCount || item.totalUnits;  
      item.totalUnits = item.unitCount;   
    });

    setItemCount(duplicateProjectData.length);
    setPluralizer(duplicateProjectData.length === 1 ? "" : "s");
    setIsUnlisted(false);

    const exactMatch = duplicateProjectData.find(item => item.matchingPercentage == 1);
    setExactMatch(exactMatch);
  }, [duplicateProjectData])

  function handleIsUnlisted(event) {
    const value = event.target.checked;
    setIsUnlisted(value)
  }

  function onContinue(event) {
    event.preventDefault();
    handleContinue();
  }

  function onCancel(event) {
    event.preventDefault();
    handleCancel();
  }

  function returnLink(projectMatch) {
    if(projectMatch.fnmaRequestStatus !== "Requested") {
      return `/project/${projectMatch.projectId}`;
    } else {
      return `/lender-project-request/${projectMatch.projectId}`;
    }
  }

  return (
    <Modal
      show={show}
      className="duplicate-found-modal"
      onHide={handleCancel}
      backdrop="static"
      size="lg"
      centered
    >
      <Modal.Header className="duplicate-modal-header" closeButton>
        <Modal.Title className="duplicate-modal-title">
          Duplicate Project{pluralizer} Found
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="duplicate-modal-body">
        {blocking ?
          exactMatch 
            ? (
              <>
                <div className="duplicate-modal-matchcount">
                  We found an exact duplicate in our records. Please use the existing project.
                </div>
                <div className="duplicate-modal-matchlist">
                  <div>
                    <div className="duplicate-project-name"><Link to={returnLink(exactMatch)} target="_blank">{exactMatch.projectName}</Link></div>
                    {exactMatch.city}, {exactMatch.state}, {exactMatch.zip5} ({exactMatch.unitCount} units)
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="duplicate-modal-matchcount">
                  We found {itemCount} duplicate project{pluralizer}. If your project already exists, please use the existing project.
                </div>
                <div className="duplicate-modal-matchlist">
                  {duplicateProjectData.map((projectData, i) => {
                      const {projectId, state, unitCount, zip5, city, projectName} = projectData;
                      return (
                        <div key={projectId}>
                          <div className="duplicate-project-name"><Link to={returnLink(projectData)} target="_blank">{projectName}</Link></div>
                          {city}, {state}, {zip5} ({unitCount} units)
                        </div>
                      );
                    }) 
                  }
                </div>
                <div className="project-unlisted" style={{marginLeft: "-10px"}}>
                  <Checkbox 
                    className={"is-unlisted " + (isUnlisted ? "checked" : "")}
                    id="isUnlisted"
                    name="isUnlisted"
                    checked={isUnlisted}
                    onChange={(event) => handleIsUnlisted(event)}
                  />
                  <label htmlFor="isUnlisted">My project isn't listed here.</label>
                </div>
              </>
              ) : (
                <>
                  <div className="duplicate-modal-matchcount">
                    We found {itemCount} potential duplicate{pluralizer}. If your project already exists, please use the existing project.
                  </div>
                  <div className="duplicate-modal-matchlist">
                    {duplicateProjectData.map(projectData => {
                        const {projectId, state, unitCount, zip5, city, projectName} = projectData;
                        return (
                          <div key={projectId}>
                            <div className="duplicate-project-name"><Link to={returnLink(projectData)} target="_blank">{projectName}</Link></div>
                            {city}, {state}, {zip5} ({unitCount} units)
                          </div>
                        )
                      }) 
                    }
                  </div>
                </>
              )}
        </Modal.Body>
      <Modal.Footer className="duplicate-modal-footer">
        {blocking 
          ? exactMatch 
            ? <Button style={{marginLeft: "auto"}} className='cancel-button cancel-modal-button' onClick={onCancel}>
                Cancel
              </Button> 
            : <>
                <Button className='cancel-button cancel-modal-button' onClick={onCancel}>Cancel</Button>
                <Button type="submit" 
                  className={"neutral-modal-button" + ((!isUnlisted || exactMatch) ? " btn-disabled" : "")} 
                  disabled={!isUnlisted || exactMatch} 
                  onClick={onContinue}
                >
                  Continue
                </Button>
              </>
          : 
            <Button type="submit" style={{marginLeft: "auto"}} className='cancel-button cancel-modal-button' onClick={onCancel}>
              Ignore and continue
            </Button>
          }
      </Modal.Footer>
    </Modal>
  );
};

export default DuplicateProjectModal;
